import json5 from "json5";

export const tryToParseStringifiedObject = (text: string) => {
    try {
        return json5.parse(text);
    } catch (error) {
        return null;
    }
};
